import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {ExternalWorkGroup} from "../../models/contractor/ExternalWorkGroup";
import {Nullable} from "../../models/common/Nullable";
import {
    ExternalWorkGroupActionTypes,
    CREATE_EXTERNAL_WORK_GROUP, CREATE_EXTERNAL_WORK_GROUP_ERROR, CREATE_EXTERNAL_WORK_GROUP_SUCCESS,
    UPDATE_EXTERNAL_WORK_GROUP, UPDATE_EXTERNAL_WORK_GROUP_ERROR,UPDATE_EXTERNAL_WORK_GROUP_SUCCESS,
    DELETE_EXTERNAL_WORK_GROUP, DELETE_EXTERNAL_WORK_GROUP_ERROR, DELETE_EXTERNAL_WORK_GROUP_SUCCESS,
    FETCH_EXTERNAL_WORK_GROUP_BY_ID, FETCH_EXTERNAL_WORK_GROUP_BY_ID_ERROR,FETCH_EXTERNAL_WORK_GROUP_BY_ID_SUCCESS,
    FETCH_EXTERNAL_WORK_GROUPS, FETCH_EXTERNAL_WORK_GROUPS_ERROR,FETCH_EXTERNAL_WORK_GROUPS_SUCCESS,
    RESTORE_EXTERNAL_WORK_GROUP, RESTORE_EXTERNAL_WORK_GROUP_ERROR, RESTORE_EXTERNAL_WORK_GROUP_SUCCESS
} from "../../actions/contractors/ExternalWorkGroupActions";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";

export interface ExternalWorkGroupState extends BasicReducerState< Nullable< ExternalWorkGroup[] >, Nullable< ExternalWorkGroup > > {

}

export function ExternalWorkGroupReducer(
    state: ExternalWorkGroupState = initialReducerState(),
    action: ExternalWorkGroupActionTypes
) {

    switch ( action.type ) {
        case FETCH_EXTERNAL_WORK_GROUPS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_EXTERNAL_WORK_GROUPS_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_EXTERNAL_WORK_GROUPS_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_EXTERNAL_WORK_GROUP_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWorkGroupId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_EXTERNAL_WORK_GROUP_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWorkGroup.externalWorkGroupId.rawValue ]: {
                        entry: action.externalWorkGroup,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_EXTERNAL_WORK_GROUP_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.externalWorkGroupId.rawValue ]: {
                        ...state.detailedEntries[ action.externalWorkGroupId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_EXTERNAL_WORK_GROUP:
        case UPDATE_EXTERNAL_WORK_GROUP:
        case DELETE_EXTERNAL_WORK_GROUP:
        case RESTORE_EXTERNAL_WORK_GROUP:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_EXTERNAL_WORK_GROUP_SUCCESS:
        case UPDATE_EXTERNAL_WORK_GROUP_SUCCESS:
        case DELETE_EXTERNAL_WORK_GROUP_SUCCESS:
        case RESTORE_EXTERNAL_WORK_GROUP_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_EXTERNAL_WORK_GROUP_ERROR:
        case UPDATE_EXTERNAL_WORK_GROUP_ERROR:
        case DELETE_EXTERNAL_WORK_GROUP_ERROR:
        case RESTORE_EXTERNAL_WORK_GROUP_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };

        default:
            return state;
    }

}